import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import styles from './MobileSelectScreen.module.scss';

/**
 * 모바일 풀스크린 선택 컴포넌트
 * - 전체 화면 오버레이로 옵션 목록 표시
 * - 라디오 버튼 스타일
 * - Figma 디자인 기반
 */
function MobileSelectScreen({ isOpen, onClose, title, options, value, onChange }) {
  const [selectedValue, setSelectedValue] = useState(value);

  // value prop이 변경되면 selectedValue 업데이트
  useEffect(
    function () {
      setSelectedValue(value);
    },
    [value],
  );

  // 선택 화면이 열릴 때 body 스크롤 방지
  useEffect(
    function () {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      return function () {
        document.body.style.overflow = '';
      };
    },
    [isOpen],
  );

  function handleSelect(optionValue) {
    setSelectedValue(optionValue);
    onChange(optionValue);
    onClose();
  }

  if (!isOpen) return null;

  const content = (
    <div className={styles.screen}>
      {/* 헤더 */}
      <header className={styles.header}>
        <div className={styles.headerSpacer} />
        <h2 className={styles.headerTitle}>{title}</h2>
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="닫기">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 6L18 18M6 18L18 6"
              stroke="#424242"
              strokeWidth="1.85"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </header>
      <div className={styles.headerDivider} />

      {/* 옵션 목록 */}
      <ul className={styles.optionList}>
        {options.map(function (option, index) {
          const isSelected = option.value === selectedValue;
          const isLast = index === options.length - 1;

          return (
            <li key={option.value} className={styles.optionItem}>
              <button
                type="button"
                className={styles.optionButton}
                onClick={() => handleSelect(option.value)}
              >
                <div className={`${styles.radio} ${isSelected ? styles.radioSelected : ''}`}>
                  {isSelected && <div className={styles.radioInner} />}
                </div>
                <span className={styles.optionLabel}>{option.label}</span>
              </button>
              {!isLast && <div className={styles.optionDivider} />}
            </li>
          );
        })}
      </ul>
    </div>
  );

  return createPortal(content, document.body);
}

MobileSelectScreen.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
};

MobileSelectScreen.defaultProps = {
  title: '선택',
  options: [],
  value: '',
  onChange: () => {},
};

export default MobileSelectScreen;
